import { IconName } from "shared/ui/icon/__generated__/IconName"

import { GlobalSearchResultType } from "../types/GlobalSearch"

export const GlobalSearchIconMap = {
  [GlobalSearchResultType.PRODUCT]: IconName.PRODUCTS,
  [GlobalSearchResultType.BUILDING_REFERENCE]: IconName.BUILDING,
  [GlobalSearchResultType.PROJECT]: IconName.FOLDER_COPY
}
